import { useState, useCallback, useRef, useEffect, memo } from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { useSwiper } from 'swiper/react';
import { useImageLoading } from '@diezhi/yesio';
import CharacterDetail from './components/CharacterDetail';
import styles from './style.module.scss';
import char1 from './components/CharacterDetail/img/char-bq-big.png';
import char2 from './components/CharacterDetail/img/char-lzy-big.png';
import char3 from './components/CharacterDetail/img/char-xm-big.png';
import char4 from './components/CharacterDetail/img/char-zql-big.png';

const preloadImgList = [char1, char2, char3, char4].map((item) => item.src);

const Character = ({ active }) => {
  const swiper = useSwiper();
  const [displayType, setDisplayType] = useState('list');
  const [characterIndex, setCharacterIndex] = useState(0);
  const preloadedRef = useRef(false);
  const { run } = useImageLoading(preloadImgList);

  const onClickDetail = (index) => {
    setCharacterIndex(index);
    setDisplayType('detail');
    swiper.mousewheel.disable();
  };

  const onCloseDetail = useCallback(() => {
    setDisplayType('list');
    swiper.mousewheel.enable();
  }, [swiper]);

  useEffect(() => {
    if (active && !preloadedRef.current) {
      run();
    }
  }, [active]);

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={displayType}
        timeout={200}
        classNames="fade"
      >
        <>
          {displayType === 'list' &&
          <div className={styles.container}>
            <div className={styles.midWrap}>
              <div
                className={styles.character1}
                onClick={() => onClickDetail(0)}
              />
              <div
                className={styles.character2}
                onClick={() => onClickDetail(1)}
              />
              <div
                className={styles.character3}
                onClick={() => onClickDetail(2)}
              />
              <div
                className={styles.character4}
                onClick={() => onClickDetail(3)}
              />
            </div>
          </div>}
          {displayType === 'detail' &&
            <CharacterDetail
              initialIndex={characterIndex}
              onClose={onCloseDetail}
            />}
        </>
      </CSSTransition>
    </SwitchTransition>

  );
};

export default memo(Character);
